import React from 'react';
import Box from '@material-ui/core/Box';
import PersonIcon from '@material-ui/icons/Person';

import DropdownNavItem from 'common/components/header/nav-items/DropdownNavItem';
import Profile from 'common/components/header/dropdowns/Profile';
import AuthActions from 'common/components/header/AuthActions';
import authService from 'common/services/authService';
import {
  FRONTEND_ABOUT_US_URL,
  FRONTEND_WALL_OF_LOVE_URL,
} from 'common/utils/constants';
import UpLgNavItem from 'common/components/header/nav-items/UpLgNavItem';
import DropdownChildren from 'common/components/header/dropdowns/common/DropdownChildren';
import { NavHeartIcon } from 'community/wall-of-love/utils/icons';
import { forIndividuals } from 'home/utils/utils';

const UpLgNavList: React.FC<IHeaderProps> = ({ RouteLink }) => {
  return (
    <>
      <Box display="flex">
        <DropdownNavItem
          label="Learn AI"
          NavItemComponent={DropdownChildren}
          dropdownData={forIndividuals}
          RouteLink={RouteLink}
        />
        <UpLgNavItem
          label="Marketplace"
          route="https://aimarketplace.co/"
          target="_blank"
          RouteLink={RouteLink}
          isReactLink={false}
        />
        <UpLgNavItem
          label="AI Planet For Teams"
          route="/teams"
          RouteLink={RouteLink}
          isReactLink={false}
        />
        <UpLgNavItem
          label="About Us"
          route={FRONTEND_ABOUT_US_URL}
          RouteLink={RouteLink}
          isReactLink={false}
        />
        <UpLgNavItem
          label="Wall Of Love"
          route={FRONTEND_WALL_OF_LOVE_URL}
          RouteLink={RouteLink}
          isReactLink
          buttonProps={{ endIcon: <NavHeartIcon /> }}
        />
      </Box>
      <Box>
        {authService.isAuthenticated && (
          <DropdownNavItem
            label={<PersonIcon />}
            NavItemComponent={Profile}
            RouteLink={RouteLink}
          />
        )}
        {!authService.isAuthenticated && <AuthActions />}
      </Box>
    </>
  );
};

export default UpLgNavList;
